"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _image = require("@site/pattern-library-core/image");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _overlay = _interopRequireDefault(require("./overlay"));
/**
 * Local Imports
*/

const SharedCard = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "SharedCard",
  class: "pl-s1pe0dw0"
});
const Card = /*#__PURE__*/(0, _react2.styled)(SharedCard)({
  name: "Card",
  class: "pl-c3ybfeq"
});
const MobileCard = /*#__PURE__*/(0, _react2.styled)(SharedCard)({
  name: "MobileCard",
  class: "pl-m62fqcy"
});

/**
 * CardItem Component.
 *
 * @param {Object} props React props
 * @param {String} props.layoutType Type of Card
 * @param {Object} props.mobilePreviewImage Mobile Image Url
 * @param {Object} props.desktopPreviewImage Desktop Image Url
 * @param {Function} props.modalFn Forwarded OnClick
 * @returns {React.ReactElement} CardItem Component
 * @public
 */

function CardItem({
  layoutType = 'default',
  text,
  mobilePreviewImage,
  desktopPreviewImage,
  modalFn,
  ...rest
}) {
  const backgroundImages = {
    portrait: mobilePreviewImage?.url,
    landscape: desktopPreviewImage?.url
  };
  if (layoutType === 'mobile') {
    return /*#__PURE__*/_react.default.createElement(MobileCard, (0, _extends2.default)({
      "data-cy": "mobile-card"
    }, backgroundImages), /*#__PURE__*/_react.default.createElement(_overlay.default, (0, _extends2.default)({
      text: text,
      modalFn: modalFn,
      primarySize: 'small'
    }, rest)));
  }
  return /*#__PURE__*/_react.default.createElement(Card, (0, _extends2.default)({
    "data-cy": "card",
    breakOn: "mobile"
  }, backgroundImages), /*#__PURE__*/_react.default.createElement(_overlay.default, (0, _extends2.default)({
    text: text,
    modalFn: modalFn
  }, rest)));
}
var _default = exports.default = CardItem;
CardItem.propTypes = {
  layoutType: _propTypes.default.oneOf(['default', 'mobile']),
  text: _propTypes.default.string,
  mobilePreviewImage: _propTypes.default.object,
  desktopPreviewImage: _propTypes.default.object,
  modalFn: _propTypes.default.func
};